// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"bb5f0677","171":"df763ef4","453":"54292a4b","764":"b849a730"}[chunkId] + ".chunk.js";
};